import {
	Button,
	Checkbox,
	FormControlLabel,
	Grid,
	Paper,
	TextField,
	Typography,
} from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import { ColDef, GridApi } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { ErrorModal } from "../components/modals/error-modal";
import { GenericPanel } from "../controls";
import { getUser } from "../repositorie/MESF-frontend-Repositorie";
import { ChangePassword } from "./changePassword";
import { useToken } from "./useToken";

export const Account = () => {
	const { getUserName, getUserId } = useToken();
	const [error, setError] = useState("");
	const [userLastName, setUserLastName] = useState<string>("");
	const [userFirstName, setUserFirstName] = useState<string>("");
	const [userId] = useState(getUserId);
	const [userParam] = useState(getUserName);
	const [userName, setUserName] = useState<string>("");
	const [userIsDomain, setUserIsDomain] = useState<boolean>(false);
	const [userIsActive, setUserIsActive] = useState<boolean>(false);
	const [open, setOpen] = useState<boolean>(false);
	const [showSuccess, setShowSuccess] = useState<boolean>(false);
	const [successMessage, setSuccessMessage] = useState<string>("");
	const [userProfiles, setUserProfiles] = useState([]);
	const [profileQuickFilter, setProfileQuickFilter] = useState("");
	const [profileGridApi, setProfileGridApi] = useState<GridApi | null>(null);
	const [userPermissions, setUserPermissions] = useState([]);
	const [permissionQuickFilter, setPermissionQuickFilter] = useState("");
	const [permissionGridApi, setPermissionGridApi] = useState<GridApi | null>(
		null,
	);

	const changePassword = () => {
		setOpen(true);
	};
	const closeChangePassword = (flag: boolean) => {
		if (flag) {
			setShowSuccess(true);
			setSuccessMessage("Password was changed successfully.");
		}
		setOpen(false);
	};

	const profilesColumnDefs: ColDef[] = [
		{
			field: "profile",
			headerName: "",
			minWidth: 20,
			flex: 1,
		},
	];
	const permissionColumnDefs: ColDef[] = [
		{
			field: "permission",
			headerName: "",
			minWidth: 20,
			flex: 1,
		},
	];

	const loadUserData = async () => {
		const resp = await getUser(userId, userParam);
		if (resp.ok) {
			const userData = get(resp, "data.tables[0].rows", null);
			setUserName(userData[0]?.UserName);
			setUserLastName(userData[0]?.LastName);
			setUserFirstName(userData[0]?.FirstName);
			setUserIsDomain(userData[0]?.AuthTypeId);
			setUserIsActive(userData[0]?.IsActive);

			const profiles = userData[0]?.Profiles
				? userData[0]?.Profiles.split(",")
						.map((profile: string) => ({ profile: profile.trim() }))
						.sort((a: { profile: string }, b: { profile: string }) =>
							a.profile.localeCompare(b.profile),
						)
				: [];
			setUserProfiles(profiles);

			const permissions = userData[0]?.Permissions
				? userData[0]?.Permissions.split(",")
						.map((permission: string) => ({ permission: permission.trim() }))
						.sort((a: { permission: string }, b: { permission: string }) =>
							a.permission.localeCompare(b.permission),
						)
				: [];
			setUserPermissions(permissions);
		} else {
			setError(resp.message);
		}
	};

	const closeMessage = () => {
		setTimeout(() => {
			setShowSuccess(false);
			setSuccessMessage("");
		}, 2000);
	};

	useEffect(() => {
		(async () => {
			await loadUserData();
		})();
	}, []);

	useEffect(() => {
		if (showSuccess === true) {
			closeMessage();
		}
	}, [showSuccess]);

	return (
		<>
			<GenericPanel
				title="Account Configuration"
				showPromptSuccess={showSuccess}
				successMessage={successMessage}
			>
				<Grid container spacing={2} style={{ marginTop: 10 }}>
					<Grid item md={12} component={Paper} style={{ padding: 10 }}>
						<Grid container md={12} spacing={2}>
							<Grid item xs={12} md={3}>
								<TextField
									aria-readonly
									label="Username"
									value={userName}
									variant="outlined"
									size="small"
									fullWidth
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								<Button
									onClick={changePassword}
									variant="contained"
									color="primary"
									startIcon={<LockIcon />}
								>
									Change Password
								</Button>
								<ChangePassword
									open={open}
									onClose={closeChangePassword}
									userId={userId}
								/>
							</Grid>
						</Grid>
						<Grid container md={12} spacing={2}>
							<Grid item xs={12} md={3}>
								<TextField
									aria-readonly
									label="Name"
									value={userFirstName}
									variant="outlined"
									size="small"
									fullWidth
								/>
							</Grid>
							<Grid item xs={12} md={3}>
								<TextField
									aria-readonly
									label="Last Name"
									value={userLastName}
									variant="outlined"
									size="small"
									fullWidth
								/>
							</Grid>
						</Grid>
						<Grid item container md={12} spacing={2}>
							<Grid item xs={12} md={3}>
								<FormControlLabel
									style={{ margin: 0 }}
									control={
										<Checkbox
											aria-readonly
											checked={userIsDomain}
											name="DomainUser"
											disabled
										/>
									}
									label="Domain User"
								/>
							</Grid>
							<Grid item xs={12} md={3}>
								<FormControlLabel
									style={{ margin: 0 }}
									control={
										<Checkbox
											aria-readonly
											checked={userIsActive}
											name="Active"
											disabled
										/>
									}
									label="Active"
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						item
						md={12}
						component={Paper}
						style={{ marginTop: 4, padding: 10 }}
					>
						<Grid container md={12} spacing={2}>
							<Grid item xs={12} md={4}>
								<Typography
									gutterBottom
									variant="h5"
									component="h2"
									className="pt-1"
								>
									Profiles
								</Typography>
								<TextField
									label="Search"
									value={profileQuickFilter}
									onChange={(e) => {
										setProfileQuickFilter(e.target.value);
										profileGridApi?.setQuickFilter(e.target.value);
									}}
									variant="outlined"
									size="small"
									fullWidth
								/>
								<div
									style={{ height: "43vh", width: "100%", marginTop: 5 }}
									className="ag-theme-material"
								>
									<AgGridReact
										rowData={userProfiles}
										rowHeight={30}
										headerHeight={0}
										columnDefs={profilesColumnDefs}
										animateRows
										suppressRowClickSelection
										onGridReady={(params) => setProfileGridApi(params.api)}
									/>
								</div>
							</Grid>
							<Grid item xs={12} md={8}>
								<Typography
									gutterBottom
									variant="h5"
									component="h2"
									className="pt-1"
								>
									Permissions
								</Typography>
								<TextField
									label="Search"
									value={permissionQuickFilter}
									onChange={(e) => {
										setPermissionQuickFilter(e.target.value);
										permissionGridApi?.setQuickFilter(e.target.value);
									}}
									variant="outlined"
									size="small"
									fullWidth
								/>
								<div
									style={{ height: "43vh", width: "100%", marginTop: 5 }}
									className="ag-theme-material"
								>
									<AgGridReact
										rowData={userPermissions}
										rowHeight={30}
										headerHeight={0}
										columnDefs={permissionColumnDefs}
										animateRows
										suppressRowClickSelection
										onGridReady={(params) => setPermissionGridApi(params.api)}
									/>
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</GenericPanel>
			<ErrorModal
				error={error}
				onHide={() => {
					setError("");
				}}
			/>
		</>
	);
};
